export default {"src":"/_next/static/media/11-icon.013c230f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};